import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMutationDeleteVisualLanguageArgs,
  BackendVisualLanguage,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteVisualLanguage($id: ID!) {
    deleteVisualLanguage(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteVisualLanguageArgs;
type Result = Pick<BackendVisualLanguage, 'id'>;

export const deleteVisualLanguage = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
